import React from 'react'
import PropTypes from 'prop-types'
import { SmartImage } from 'shared/UI/SmartImage'
import { SVG_EXTENSION } from 'shared/constants'

import './style.css.scss'

const CustomIcon = ({ linkUrl, image, onClick, iconSizeClass }) => {

  const isIconType = () => {
    return image.url.endsWith(SVG_EXTENSION)
  }

  return (
    <SmartImage
      config={{...image, fit:'contain'}}
      onClick={onClick}
      className={`custom-icon
        ${iconSizeClass}
        ${image.shape ? image.shape : 'square'}
        ${!linkUrl ? ' disabled' : ''}
        ${isIconType() ? 'icon-type' : 'image-type'}`} />
  )
}

CustomIcon.propTypes = {
  linkUrl: PropTypes.string,
  image: PropTypes.object.isRequired,
  iconSizeClass: PropTypes.string
}

export default CustomIcon